// Featured Programmes Data - Dynamic content for home page urgent CTAs
// Update this file to change featured programmes without modifying components

export const FeaturedProgrammesData = {
  // Active featured programmes to display on home page
  // Add as many as needed, they will be displayed in order
  programmes: [
    {
      id: "ncil-youth-coding-camp",
      title: "Young People Coding & AI Camp",
      tagline: "Free coding programme for young people",
      description:
        "Ages 10–18 • FREE • Learn by building, then share what you have made. See the story of our young people presenting their work during a visit to Visa Europe HQ.",
      targetAudience: "Young people aged 10-18 in Barking & Dagenham",
      location: "Barking & Dagenham",
      cost: "Free",
      urgencyText: "Work Worth Showing",
      ctaText: "See the story",
      ctaUrl: "/community-projects/ncil-youth-coding-camp#visa-career-day",
      featured: true,
      startDate: "2026-03-01", // ISO format - can be used for sorting/automatic expiry
      endDate: "2026-05-10",
      badge: "FEATURED",
      badgeColor: "#1a5daa",
      icon: "</>",
    },
    {
      id: "women-4-women",
      title: "Women 4 Women",
      tagline: "Empowering Women Through Community",
      description:
        "An inclusive, peer-led platform for women at every stage of enterprise — from a seed of an idea to a business you're proud of. Network, share, connect and grow together.",
      targetAudience: "Women at every stage of enterprise, from any background",
      location: "East London",
      cost: "Free",
      urgencyText: "Join the Community",
      ctaText: "Register Interest",
      ctaUrl: "/community-projects/women-4-women",
      featured: true,
      startDate: null, // Ongoing programme
      endDate: null,
      badge: "ONGOING",
      badgeColor: "#9b5e6e",
      icon: "👭",
    },
  ],

  // Settings for display
  settings: {
    maxDisplayCount: 2, // Maximum number of featured programmes to show
    showUrgency: true,
    urgencyThresholdDays: 14, // Show "urgent" styling if start date is within this many days
    defaultCtaText: "Learn More",
  },

  // Helper function to check if a programme is currently active
  isActive: (programme) => {
    if (!programme.featured) return false;
    const now = new Date();
    if (programme.endDate && new Date(programme.endDate) < now) return false;
    return true;
  },

  // Helper function to get active programmes sorted by start date
  getActiveProgrammes: function () {
    return this.programmes
      .filter((p) => this.isActive(p))
      .sort((a, b) => {
        if (!a.startDate) return 1;
        if (!b.startDate) return -1;
        return new Date(a.startDate) - new Date(b.startDate);
      })
      .slice(0, this.settings.maxDisplayCount);
  },

  // Helper function to check if programme is urgent (starting soon)
  isUrgent: function (programme) {
    if (!programme.startDate) return false;
    const start = new Date(programme.startDate);
    const now = new Date();
    const diffDays = Math.ceil((start - now) / (1000 * 60 * 60 * 24));
    return diffDays <= this.settings.urgencyThresholdDays && diffDays >= 0;
  },
};

// Quick reference for navigation (used by FeaturedProgrammes component)
export const FeaturedProgrammesCategories = [
  {
    id: "ncil-youth-coding-camp",
    title: "Young People Coding & AI Camp",
    url: "/community-projects/ncil-youth-coding-camp",
  },
  {
    id: "women-4-women",
    title: "Women 4 Women",
    url: "/community-projects/women-4-women",
  },
];
